import { z } from "zod";

/**
 * Public marketing contact form (landing page → inbox).
 *
 * Copied from `api/src/contracts/contact/contact.ts` (ADR-043).
 */
export const contactRequestSchema = z.object({
  name: z.string().trim().min(1).max(120),
  email: z.string().trim().email().max(254),
  company: z.string().trim().max(160).optional(),
  message: z.string().trim().min(10).max(4_000),
});

export type ContactRequest = z.infer<typeof contactRequestSchema>;

export const contactResponseSchema = z.object({
  ok: z.literal(true),
});

export type ContactResponse = z.infer<typeof contactResponseSchema>;
